import { render, staticRenderFns } from "./PlatinumEyesTab.vue?vue&type=template&id=f17ce6c2&scoped=true&"
import script from "./PlatinumEyesTab.vue?vue&type=script&lang=js&"
export * from "./PlatinumEyesTab.vue?vue&type=script&lang=js&"
import style0 from "./PlatinumEyesTab.vue?vue&type=style&index=0&id=f17ce6c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17ce6c2",
  null
  
)

export default component.exports